import { render, staticRenderFns } from "./LPks.vue?vue&type=template&id=a949a900&scoped=true"
import script from "./LPks.vue?vue&type=script&lang=js"
export * from "./LPks.vue?vue&type=script&lang=js"
import style0 from "./LPks.vue?vue&type=style&index=0&id=a949a900&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a949a900",
  null
  
)

export default component.exports